var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "k-page page" },
    [_vm._t("default"), _c("div", { staticClass: "bottom-spacer" })],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }